import "./WorkCardStyles.css"
import WorkCardData from "./WorkCardData"
import WorkCardData2 from "./WorkCardData2"
import { Card, Text, Link, Row } from "@nextui-org/react";

const Work2 = () => {
    return (
        <div className="work-container">
            <h1 className="project-heading">Featured</h1>
            <div className="project-container">
                {WorkCardData.map((val, index) => {
                    return (
                        <Card isHoverable variant="bordered" css={{ p: "$6", mw: "400px"}}>
                            <Card.Image
                                src={val.imgsrc}
                                objectFit="cover"
                            />
                            <Card.Header>
                                <Text h2 css={{ lineHeight: "$xs" }}>
                                    {val.title}
                                </Text>
                            </Card.Header>
                            <Card.Body css={{ py: "$2" }}>
                                <Text>
                                    {val.text}
                                </Text>
                                <Text color="white">-----</Text>
                                <Text>
                                    {val.tech}
                                </Text>
                            </Card.Body>
                            <Card.Footer>
                                <Row justify="flex">

                                    <Link
                                        icon
                                        color="primary"
                                        target="_blank"
                                        href= {val.view}
                                    >
                                        Visit project
                                    </Link>
                                </Row>

                            </Card.Footer>
                        </Card>
                    )
                })}

            </div>
            <h1 className="project-heading">Other Projects</h1>
            <div className="project-container">
                {WorkCardData2.map((val, index) => {
                    return (
                        <Card isHoverable variant="bordered" css={{ p: "$6", mw: "400px"}}>
                            <Card.Image
                                src={val.imgsrc}
                                objectFit="cover"
                            />
                            <Card.Header>
                                <Text h2 css={{ lineHeight: "$xs" }}>
                                    {val.title}
                                </Text>
                            </Card.Header>
                            <Card.Body css={{ py: "$2" }}>
                                <Text>
                                    {val.text}
                                </Text>
                                <Text color="white">-----</Text>
                                <Text>
                                    {val.tech}
                                </Text>
                            </Card.Body>
                            <Card.Footer>
                                <Row justify="flex">

                                    <Link
                                        icon
                                        color="primary"
                                        target="_blank"
                                        href= {val.view}
                                    >
                                        Visit project
                                    </Link>
                                </Row>

                            </Card.Footer>
                        </Card>
                    )
                })}

            </div>

        </div>
    )
}

export default Work2;